import { PRACTICE, LOGO_URL } from "../../lib/data";

export const Footer = () => (
  <footer className="bg-ink text-white/80">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-14 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <img
          src={LOGO_URL}
          alt="Dr. Venkat Subramaniam — Best Urologist in Chennai"
          className="h-20 w-auto mb-4 logo-knockout-dark"
        />
        <p className="text-xs tracking-[0.18em] uppercase text-forest mt-1 font-semibold">M.S, D.Lap, M.Ch (Uro)</p>
        <p className="mt-5 text-sm text-white/60 max-w-sm leading-relaxed">
          Senior consultant in laparoscopic, transplant and robotic urological surgery. Practising in Chennai.
        </p>
      </div>

      <div className="lg:col-span-3">
        <p className="text-xs tracking-[0.18em] uppercase text-white/50 mb-4 font-semibold">Practice</p>
        <ul className="space-y-2 text-sm">
          <li><a href="/#services" className="link-underline hover:text-white">Specialities</a></li>
          <li><a href="/#about" className="link-underline hover:text-white">About</a></li>
          <li><a href="/#testimonials" className="link-underline hover:text-white">Testimonials</a></li>
          <li><a href="/#faq" className="link-underline hover:text-white">FAQ</a></li>
          <li><a href="/#book" className="link-underline hover:text-white">Book Consultation</a></li>
          <li><a href="/connect" className="link-underline hover:text-white">Follow on Social</a></li>
        </ul>
      </div>

      <div className="lg:col-span-4">
        <p className="text-xs tracking-[0.18em] uppercase text-white/50 mb-4 font-semibold">Contact</p>
        <p className="text-sm leading-relaxed">{PRACTICE.address}</p>
        <p className="mt-3 text-sm">
          <a href={`tel:${PRACTICE.phone.replace(/\s/g, "")}`} className="link-underline hover:text-white">{PRACTICE.phone}</a><br />
          <a href={`https://wa.me/${PRACTICE.whatsapp}`} className="link-underline hover:text-white" target="_blank" rel="noopener noreferrer">WhatsApp {PRACTICE.whatsappDisplay}</a>
        </p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-5 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-white/50">
        <p>© {new Date().getFullYear()} Dr. Venkatsubramaniam. Private Urological Practice.</p>
        <p className="tracking-[0.18em] uppercase font-semibold">Technology Led — Expertise Driven</p>
      </div>
    </div>
  </footer>
);
